module.exports = __webpack_public_path__ + "assets/img/ko-c50f0632.png";